<template>
  <div>
    <div style="padding: 10px 10px">
      <div style="text-align: center; font-size: 18px; font-weight: bold; margin-bottom: 10px">筛选条件</div>
      <div class="fliterDiv">
        <label style="flex-shrink: 0">开始时间</label>
        <label class="value"
               @click="openDateTimePickerBeg">
        <span v-if="enterDateBeg">{{enterDateBeg}}</span>
        <span v-else style="color: orange">请选择</span>
        </label>
        <van-popup v-model="showDateDatePickerBeg"
                   position="bottom"
                   style=" height: 60%">
          <van-datetime-picker v-model="editEnterDateBeg"
                               type="date"
                               title="选择开始时间"
                               :min-date="minDate"
                               :max-date="maxDate"
                               @confirm="confirmEnterDateBeg"
                               @cancel="cancelEnterDateBeg">
          </van-datetime-picker>
        </van-popup>
      </div>
      <div class="fliterDiv">
        <label style="flex-shrink: 0">结束时间</label>
        <label class="value"
               @click="openDateTimePickerEnd">
        <span v-if="enterDateEnd">{{enterDateEnd}}</span>
        <span v-else style="color: orange">请选择</span>
        </label>
        <van-popup v-model="showDateDatePickerEnd"
                   position="bottom"
                   style=" height: 60%">
          <van-datetime-picker v-model="editEnterDateEnd"
                               type="date"
                               title="选择结束时间"
                               :min-date="minDate"
                               :max-date="maxDate"
                               @confirm="confirmEnterDateEnd"
                               @cancel="cancelEnterDateEnd">
          </van-datetime-picker>
        </van-popup>
      </div>
      <div class="fliterDiv">
        <label style="flex-shrink: 0">技师</label>
        <van-tag type="primary" style="margin-left: 10px;">
            {{picker.text}}
        </van-tag>
        <van-button round size="mini" icon="plus" type="info" @click="openPickTechnician" style="margin-left: 10px; height: 22px;"></van-button>
      </div>
    </div>
    <div style="width: 100%; display: flex; justify-content: center; margin-top: 8px">
      <van-button style="width: 40%; height: 40px; font-size: 16px" size="small" @click="resetFilters">重置</van-button>
      <van-button style="width: 40%; height: 40px; font-size: 16px" size="small" type="primary"
                  @click="regbut">完成
      </van-button>
    </div>

    <van-popup v-model="pickershow" position="bottom" style="height: 70%;" round safe-area-inset-bottom>
      <van-picker
        title="选择技师"
        show-toolbar
        :columns="TsList"
        @confirm="onSelect"
        @cancel="pickershow = false">
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { Button, DatetimePicker, Popup, Tag, Picker } from 'vant'

export default {
    name: 'WxWorkReportFilter',
    components: {
      [Button.name]: Button,
      [Popup.name]: Popup,
      [DatetimePicker.name]: DatetimePicker,
      [Tag.name]: Tag,
      [Picker.name]: Picker
    },
    props: {
      TsList: {
        type: Array,
        required: true
      }
    },
    data () {
        return {
            enterDateBeg: null,
            enterDateEnd: null,
            editEnterDateBeg: null,
            editEnterDateEnd: null,
            showDateDatePickerBeg: false,
            showDateDatePickerEnd: false,
            pickershow: false,
            picker: {
                id: null,
                text: null
            }
        }
    },
    created () {
        if (this.TsList.length === 1) {
           this.picker.id = this.TsList[0].id
            this.picker.text = this.TsList[0].text
        }
    },
    methods: {
      resetFilters () {
        this.enterDateBeg = null
        this.enterDateEnd = null
        this.picker.id = null
        this.picker.text = null
      },
      openDateTimePickerBeg () {
          this.editEnterDateBeg = new Date()
          this.showDateDatePickerBeg = true
      },
      openDateTimePickerEnd () {
        this.editEnterDateEnd = new Date()
        this.showDateDatePickerEnd = true
      },
      confirmEnterDateBeg () {
        this.enterDateBeg = new Date(this.editEnterDateBeg).format('yyyy-MM-dd') + ' 00:00:00'
        this.showDateDatePickerBeg = false
      },
      cancelEnterDateBeg () {
        this.showDateDatePickerBeg = false
      },
      confirmEnterDateEnd () {
        this.enterDateEnd = new Date(this.editEnterDateEnd).format('yyyy-MM-dd') + ' 23:59:59'
        this.showDateDatePickerEnd = false
      },
      cancelEnterDateEnd () {
        this.showDateDatePickerEnd = false
      },
      openPickTechnician () {
        this.pickershow = true
      },
      onSelect (value) {
        this.pickershow = false
        this.picker.text = value.text
        this.picker.id = value.id
      },
      regbut () {
        this.$emit('onTechnician', this.enterDateBeg, this.enterDateEnd, this.picker, false)
      }
    },
    computed: {
        minDate () {
        const date = new Date()
        date.setTime(date.getTime() - 365 * 5 * 24 * 60 * 60 * 1000)
        return date
      },
      maxDate () {
        return new Date()
      }
    }
}
</script>

<style lang="scss" scoped>
.fliterDiv{
    margin: 16px 12px;
    font-size: 16px;
    height: 22px;
    line-height: 22px;
    display: flex
}
</style>
